import React from 'react'

import { useDrawerContext } from 'hooks/drawer'

import Drawer from '../Drawer'

// see drawer props
const ContextDrawer = (props) => {
  const {
    setIsDrawerOpening,
    setIsDrawerOpened,
    setIsDrawerClosing,
    setIsDrawerClosed,
    setIsDrawerVisible,
    isDrawerVisible,
    showDrawerMask,
    drawerWidth,
  } = useDrawerContext()

  return (
    <Drawer
      setIsDrawerOpening={setIsDrawerOpening}
      setIsDrawerOpened={setIsDrawerOpened}
      setIsDrawerClosing={setIsDrawerClosing}
      setIsDrawerClosed={setIsDrawerClosed}
      setIsDrawerVisible={setIsDrawerVisible}
      isDrawerVisible={isDrawerVisible}
      showDrawerMask={showDrawerMask}
      drawerWidth={drawerWidth}
      visibleWidth={drawerWidth}
      {...props}
    />
  )
}

export default ContextDrawer
